import type { SlotAwareField } from '@cli-types/core-engine/schema-reader.js'
import { walkSlot } from './walk-slot.js'

export function collectInvalidSlotErrors(
  fields: SlotAwareField[],
  rootPath: string,
  errors: string[]
): void {
  const prefix = rootPath ? `${rootPath}.` : ''
  for (const field of fields) {
    walkSlot(field, `${prefix}${field.name ?? 'unnamed'}`, errors)
  }
}
